import cpt_chart_scatter_option from "@/components/echarts/attrs/cpt-chart-scatter-option";

const op = JSON.parse(JSON.stringify(cpt_chart_scatter_option))
const dataStr = JSON.stringify([
    {
        group:'1990年',
        data:[
            [-20, 110, 30, 'Australia'],
            [-31, 37.4, 27, 'Canada'],
            [15, 68, 11, 'China'],
            [-36, 74.7, 10, 'Cuba'],
            [-228, -75, 49, 'Finland'],
            [29, 77.1, 26, 'France'],
            [31, 75.4, 38, 'Germany'],
            [28, 78.1, 25, 'Iceland'],
            [-77, -57.7, 27, 'India'],
            [29, 79.1, 12, 'Japan'],
            [-6, -61.9, 20, 'North Korea'],
            [-200, 72, 42, 'South Korea'],
            [21, 75.4, 33, 'New Zealand'],
            [43, -6.8, 12, 'Norway'],
            [-10, 71, 38, 'Poland'],
            [199, 69.6, 14, 'Russia'],
            [106, 17, 53, 'Turkey'],
            [264, -72, 57, 'United Kingdom'],
            [172, 35.4, 25, 'United States']
        ]
    },{
        group:'2015年',
        data:[
            [-110, 110, 30, 'Australia'],
            [-31, 77.4, 27, 'Canada'],
            [15, -68, 11, 'China'],
            [136, 74.7, 10, 'Cuba'],
            [-228, 75, 49, 'Finland'],
            [29, -77.1, 36, 'France'],
            [-31, 75.4, 28, 'Germany'],
            [28, 78.1, 25, 'Iceland'],
            [-177, -57.7, 17, 'India'],
            [29, 79.1, 12, 'Japan'],
            [206, 67.9, 20, 'North Korea'],
            [120, 72, 42, 'South Korea'],
            [-21, -75.4, 33, 'New Zealand'],
            [43, -20, 42, 'Norway'],
            [100, 70.8, 38, 'Poland'],
            [199, 69.6, 14, 'Russia'],
            [-106, -67.3, 53, 'Turkey'],
            [264, 75.7, 57, 'United Kingdom'],
            [172, -75.4, 25, 'United States']
        ]
    }
])
op.cptDataForm.dataText = dataStr
op.attribute.xAxis.splitLine.show = false
op.attribute.yAxis.splitLine.show = false
op.attribute.scale = 1
export default op